import { Http } from '../dimijs/src/lib/sources/http';

export interface IGuestUuid {
  _id: string;
  uuid: string;
  surveyCount: number;
  firstSeen: number;
  lastSeen: number;
}

export const getGuestsUuidSource = (store: any) => {
  const source = new Http<IGuestUuid, string>('_id');
  source.httpEndPoint = '/api/users/guests_uuid';
  return source;
};